import { useTranslations } from 'next-intl';
import { cn, formatCount } from '@/app/utils';

interface DataDisplayProps {
  className?: string;
  isSubmitSuccess: boolean;
  shareUseCount?: number;
  allowCopy?: boolean;
  shareCopyCount?: number;
  isAuthor?: boolean;
  collectCount?: number;
}

export const DataDisplay = ({
  className,
  isSubmitSuccess,
  shareUseCount = 0,
  allowCopy,
  shareCopyCount = 0,
  collectCount = 0,
  isAuthor,
}: DataDisplayProps) => {
  const trans = useTranslations('elements');
  if (!isSubmitSuccess || ((!shareUseCount || shareUseCount <= 0) && !allowCopy)) {
    return null;
  }
  const showCopyCount = isAuthor && (shareCopyCount || 0) > 0;
  // TODO 后续恢复此行代码
  // const showCopyCount = allowCopy && (shareCopyCount || 0) > 0;

  // 计算显示的数据项数量
  const showShareUse = (shareUseCount || 0) > 0;
  const showCollect = collectCount > 0;
  const showCopy = showCopyCount;
  const visibleItems = [showShareUse, showCollect, showCopy].filter(Boolean).length;

  return (
    <div className={cn('flex items-center justify-center', className)}>
      {showShareUse && (
        <div
          className={cn(
            'flex items-center px-2 text-system-white text-system-white48 text-xs',
            visibleItems > 1 &&
              (showCollect || showCopy) &&
              'after:-translate-y-1/2 relative after:absolute after:top-1/2 after:right-0 after:bottom-0 after:h-4 after:w-[1px] after:bg-system-white16 after:content-[""]',
          )}
        >
          {`${formatCount(shareUseCount ?? 0)} ${trans('submit.dialog.form.used')}`}
        </div>
      )}
      {showCollect && (
        <div
          className={cn(
            'flex items-center px-2 text-system-white text-system-white48 text-xs',
            visibleItems > 1 &&
              showCopy &&
              'after:-translate-y-1/2 relative after:absolute after:top-1/2 after:right-0 after:bottom-0 after:h-4 after:w-[1px] after:bg-system-white16 after:content-[""]',
          )}
        >
          {`${formatCount(collectCount ?? 0)} ${trans('submit.dialog.form.collected')}`}
        </div>
      )}
      {showCopy && (
        // {allowCopy && (shareCopyCount || 0) > 0 && (
        <div className="flex items-center px-2 text-system-white text-system-white48 text-xs">
          {`${formatCount(shareCopyCount ?? 0)} ${trans('submit.dialog.form.joinShare')}`}
        </div>
      )}
    </div>
  );
};
